import type { FC } from "react";
import { useRef } from "react";
import { CSSTransition } from "react-transition-group";

import { SearchForm } from "@ui/components/Search/components/SearchForm";
import { useOutsideClick } from "@ui/hooks/useOutsideClick";
import { useTranslations } from "@ui/providers/useTranslations";

import styles from "./SearchHeaderBanner.module.scss";

export type SearchHeaderBannerProps = {
  isOpened: boolean;
  resultsPageUrl: string;
  onClose: () => void;
};

export const SearchHeaderBanner: FC<SearchHeaderBannerProps> = ({ isOpened, resultsPageUrl, onClose }) => {
  const searchContainerRef = useRef<HTMLDivElement>(null);
  const { __ } = useTranslations();
  useOutsideClick(searchContainerRef, onClose, {
    excludeSelectors: ["[data-search-button]"],
  });

  return (
    <CSSTransition
      in={isOpened}
      timeout={115}
      classNames={{
        enter: styles.fadeInFromTop,
        exit: styles.fadeOutToTop,
      }}
      nodeRef={searchContainerRef}
      unmountOnExit
    >
      <div className={styles.searchContainer} data-testid="searchContainer" ref={searchContainerRef}>
        <div className={styles.searchAnimation}>
          <div className={styles.searchFormWrapper}>
            <SearchForm resultsPage={resultsPageUrl} />
          </div>
        </div>
      </div>
    </CSSTransition>
  );
};
